import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Beaker } from 'lucide-react';

const SpecialMentions = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section id="special-mentions" className="bg-black py-24 border-t border-zinc-900">
      <div className="bb-container px-4">
        
        {/* TITOLO SEZIONE - MENZIONI (BIANCO) SPECIALI (GIALLO) */}
        <div className="mb-12">
          <span className="uppercase tracking-[0.5em] text-[10px] font-bold text-[#c49a45] block mb-4">
            Studia la sfida prima di entrare nell'arena 
          </span>
          <h2 className="bb-display text-5xl md:text-7xl text-white uppercase leading-none">
            MENZIONI <span className="text-[#c49a45]">SPECIALI</span>
          </h2>
          <p className="mt-4 text-zinc-500 uppercase tracking-widest text-xs font-bold">
            "Lo stile che vince oggi decreta la sfida di domani"
          </p>
        </div>

        {/* BOX CONTENUTO */}
        <div className="border border-[#c49a45]/30 bg-zinc-950/50 p-8 md:p-12 relative overflow-hidden">
          <div className="relative z-10 flex flex-col lg:flex-row gap-12 items-center lg:items-start justify-between">
            
            {/* COLONNA SINISTRA: TESTI E PULSANTE */}
            <div className="w-full lg:max-w-3xl">
              {/* PRIMA PARTE: PASSAGGIO DEL TESTIMONE CON FRASE IN GIALLO */}
              <div className="mb-10">
                <h3 className="text-white font-black text-xl uppercase mb-4 tracking-tight">
                  Il Passaggio del Testimone
                </h3>
                <p className="text-zinc-300 text-lg leading-relaxed"> Il 
                  <span className="text-[#c49a45] font-bold"> Passaggio del testimone</span> è l'anima evolutiva del Beer Battle: 
                  il vincitore con lo stile di birra che lo ha portato alla vittoria stabilisce il tema della Menzione Speciale per l'edizione successiva. 
                  Non è solo un premio, ma una sfida tecnica lanciata dal campione ai futuri partecipanti.
                </p>
              </div>
              
              {/* SECONDA PARTE: LA VISIONE CON NOME IN GIALLO */}
              <div>
                <h3 className="text-white font-black text-xl uppercase mb-4 tracking-tight">
                  La menzione speciale di <span className="text-[#c49a45]">Nick Budnitsky</span>
                </h3>
                <p className="text-zinc-300 text-lg leading-relaxed">
                  Con il vincitore del 2025, Nick Budnitsky, la Belgian Golden Strong Ale sarà lo stile di riferimento per la Menzione Speciale 2026, 
                  offrendo ai nuovi homebrewers l'opportunità di approfondire 
                  i segreti tecnici che hanno reso questa birra la migliore dell’Arena."
                </p>
              </div>

              {/* TASTO RICETTA ESPANDIBILE */}
              <button 
                onClick={() => setIsOpen(!isOpen)}
                className="mt-10 flex items-center gap-4 bg-[#c49a45] text-black px-6 py-3 font-black text-xs uppercase tracking-[0.2em] hover:bg-[#d4aa55] transition-all"
              >
                <Beaker size={16} />
                {isOpen ? 'Chiudi Ricetta' : 'Vedi la Ricetta'}
                {isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
              </button>
            </div>

            {/* COLONNA DESTRA: IMMAGINE ATTESTATO RIDOTTA CON VELO NERO */}
            <div className="w-full lg:w-auto flex-shrink-0 max-w-[260px] md:max-w-[360px] lg:max-w-[300px] border border-zinc-900 bg-black/40 p-2 group overflow-hidden relative">
              <div className="absolute inset-0 bg-black/40 transition-opacity group-hover:opacity-20 z-10 pointer-events-none" />
              <img 
                src="/assets/Certificato-di-Nick.webp" 
                alt="Certificato Menzione Speciale Nick Budnitsky" 
                className="w-full h-auto object-contain transition-opacity duration-500 shadow-2xl relative z-0"
              />
            </div>

          </div>

          {/* PARTE ESPANDIBILE: LA RICETTA */}
          {isOpen && (
            <div className="mt-12 pt-12 border-t border-zinc-900 animate-in fade-in slide-in-from-top-4 duration-500">
              
              {/* GRID PARAMETRI E INGREDIENTI */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
                
                {/* COLONNA SINISTRA: PARAMETRI + DOWNLOAD PDF SUBITO SOTTO */}
                <div className="space-y-8">
                  <div className="space-y-4">
                    <h4 className="text-[#c49a45] font-bold uppercase text-xs tracking-widest">Parametri Tecnici</h4>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="bg-black/40 p-4 border border-zinc-900">
                        <span className="text-zinc-500 text-[10px] block uppercase">OG</span>
                        <span className="text-white font-mono text-xl">1.076</span>
                      </div>
                      <div className="bg-black/40 p-4 border border-zinc-900">
                        <span className="text-zinc-500 text-[10px] block uppercase">FG</span>
                        <span className="text-white font-mono text-xl">1.005</span>
                      </div>
                      <div className="bg-black/40 p-4 border border-zinc-900">
                        <span className="text-zinc-500 text-[10px] block uppercase">ABV</span>
                        <span className="text-white font-mono text-xl">9.25%</span>
                      </div>
                      <div className="bg-black/40 p-4 border border-zinc-900">
                        <span className="text-zinc-500 text-[10px] block uppercase">IBU</span>
                        <span className="text-white font-mono text-xl">26.89</span>
                      </div>
                    </div>
                  </div>

                  {/* DOWNLOAD PDF INTEGRATO SOTTO I PARAMETRI PER EVITARE ALTEZZE INUTILI */}
                  <div className="pt-4 border-t border-zinc-900/40">
                    <p className="text-zinc-600 text-[10px] uppercase tracking-[0.15em] mb-2 leading-relaxed">
                      Ringraziamo Nick Budnitsky per la condivisione dei dettagli di produzione.
                    </p>
                    <a 
                      href="/assets/ricetta-belgian-golden-strong-ale-nick.pdf" 
                      download
                      className="inline-block text-[#c49a45] hover:text-[#d4aa55] font-bold text-xs uppercase tracking-wider transition-colors border-b border-transparent hover:border-[#d4aa55] pb-0.5"
                    >
                      Scarica la ricetta completa in PDF →
                    </a>
                  </div>
                </div>

                {/* COLONNA DESTRA: INGREDIENTI CHIAVE */}
                <div className="space-y-6">
                  <div>
                    <h4 className="text-[#c49a45] font-bold uppercase text-xs tracking-widest mb-3">Malti (8.7 kg)</h4>
                    <ul className="space-y-2 text-zinc-400 text-xs tracking-wide">
                      <li>
                        <span className="text-white font-bold font-mono mr-2">8.5 kg</span> (85%) — Castle Malting Chateau Pilsen 2-Row <span className="text-zinc-600 italic text-[11px] ml-1">3.5 EBC</span>
                      </li>
                      <li>
                        <span className="text-white font-bold font-mono mr-2">100 g</span> (1%) — Castle Malting Chateau Cara Gold <span className="text-zinc-600 italic text-[11px] ml-1">120 EBC</span>
                      </li>
                      <li>
                        <span className="text-white font-bold font-mono mr-2">100 g</span> (1%) — Castle Malting Chateau Vienna <span className="text-zinc-600 italic text-[11px] ml-1">5.5 EBC</span>
                      </li>
                    </ul>
                  </div>

                  <div>
                    <h4 className="text-[#c49a45] font-bold uppercase text-xs tracking-widest mb-3">Luppoli (135 g)</h4>
                    <ul className="space-y-2 text-zinc-400 text-xs tracking-wide">
                      <li>
                        <span className="text-white font-bold font-mono mr-2">60 g</span> (11 IBU) — Tettnang 2.7% <span className="text-zinc-600 uppercase text-[10px] ml-2 font-bold tracking-wider">Bollitura — 60 min</span>
                      </li>
                      <li>
                        <span className="text-white font-bold font-mono mr-2">35 g</span> (13 IBU) — East Kent Goldings (EKG) 6.9% <span className="text-zinc-600 uppercase text-[10px] ml-2 font-bold tracking-wider">Bollitura — 30 min</span>
                      </li>
                      <li>
                        <span className="text-white font-bold font-mono mr-2">20 g</span> (1 IBU) — East Kent Goldings (EKG) 6.9% <span className="text-[#c49a45] uppercase text-[10px] ml-2 font-bold tracking-wider">Aroma — 10 min hopstand</span>
                      </li>
                      <li>
                        <span className="text-white font-bold font-mono mr-2">20 g</span> (0 IBU) — Tettnang 2.7% <span className="text-[#c49a45] uppercase text-[10px] ml-2 font-bold tracking-wider">Aroma — 10 min hopstand</span>
                      </li>
                    </ul>
                  </div>

                  <div>
                    <h4 className="text-[#c49a45] font-bold uppercase text-xs tracking-widest mb-2">Lievito</h4>
                    <p className="text-zinc-400 text-xs tracking-wide">
                      <span className="text-white font-bold font-mono mr-2">4 pacchetti</span> — Mangrove Jack's M41 Belgian Ale Yeast <span className="text-zinc-600 italic text-[11px] ml-1">(Attenuazione 85%)</span>
                    </p>
                  </div>
                </div>
              </div>

            </div>
          )}
        </div>

        <p className="text-zinc-600 text-[9px] uppercase tracking-[0.2em] mt-8 text-center italic">
          "Menzioni Speciali" è un format esclusivo ideato per condividere la cultura dell'homebrewing d'eccellenza.
        </p>
      </div>
    </section>
  );
};

export default SpecialMentions;